import { z } from "zod/v4";

import { LivePriceDtoSchema } from "../dtos/live-prices";

export const OnboardingInfoFe = z.object({
  preferredName: z.string(),
  preferredEmail: z.string(),
  companyRole: z.string().nullable(),
  otherRole: z.string().optional(),
  teamDescription: z.string().nullable(),
  agencyPrimaryOperator: z.string().nullish(),
  previousExperience: z.string().nullable(),
  storeType: z.string(),
  userReportedOrderCount: z.string(),
  productionStoreUrl: z.string().optional(),
  goals: z.string().array(),
  otherGoal: z.string().optional(),
  focus: z.string().nullable(),
  recommendedPlan: z.string().nullable(),
  buyingIntention: z.string().nullable(),
  otherBuyingIntention: z.string().optional(),
  sourceAttribution: z.string().nullable(),
  otherSourceAttribution: z.string().optional(),
  recommendedLivePlan: LivePriceDtoSchema.nullable(),
});

export type OnboardingInfoFe = z.infer<typeof OnboardingInfoFe>;
